// src/pages/UserProfile/ui/UserMeetingsIsland.jsx
import React, { useState, useCallback } from 'react';
import {
  Trash2,
  Mic,
  Play,

} from 'lucide-react';
import './UserMeetingsIsland.css';
import Pagination from '../../../components/Pagination/Pagination';
import { formatNice } from '../../../utils/formatNice';
import FeedbackModal from '../../../components/FeedbackModal/FeedbackModal';
import { getVoiceProfile } from '../../../config/voiceProfiles';

export default function UserMeetingsIsland({
  paginatedMeetings = [],
  fmt,                    // (d: ISO) => string
  onDeleteMeeting,        // (id: string) => Promise<void>
  onResumeMeeting,        // (pm) => void
  meetPage,
  meetPages,
  onPageChange,
}) {
  const [activeMeeting, setActiveMeeting] = useState(null); // { ...pm } | null


  const openFeedback = useCallback((pm) => {
    if (!pm?.feedback) return;
    setActiveMeeting(pm);
  }, []);

  const hasData = paginatedMeetings?.length > 0;
  const closeFeedback = useCallback(() => setActiveMeeting(null), []);
  return (
    <section className="dashboard-island">


      <header className="profile-island-head">
        <div className="profile-island-title">
          <Mic size={28} /> <span>Practice Conversations</span>
        </div>

      </header>

      {!hasData ? (
        <div className="empty-state">
          <p className="empty-state-text">You don’t have any practice conversations yet.</p>
          <button className="primary-button" onClick={() => onResumeMeeting({ id: 'new' })}>
            Create Conversation
          </button>
        </div>
      ) : (
        <>
          <div className="pm-list">
          {paginatedMeetings.map((pm) => {
  // Title is now always derived from meetingType
  const title = formatNice(pm.meetingType);

  // No more custom checks
  const role = pm.userRole;
  const industry = pm.industry;

  const hasFeedback = !!pm.feedback;
  const voiceProfile = getVoiceProfile(pm.aiVoice);

  return (
    <article
      key={pm.id}
      className={`pm-card ${hasFeedback ? 'has-feedback' : ''}`}
      role="button"
      tabIndex={0}
    >
      <img
        className="pm-avatar"
        src={voiceProfile.image}
        alt={`${voiceProfile.label} voice`}
      />

      {/* Content */}
      <div className="pm-card__content">
        {/* Title */}
        <h3 className="pm-title">{title}</h3>

        {/* Inline meta */}
        <div className="pm-meta">
          {role && <span>{formatNice(role)}</span>}
          {industry && <span>{formatNice(industry)}</span>}
          <span>{pm.duration} min</span>
          <span>{fmt(pm.createdAt)}</span>
        </div>
      </div>

      {/* Actions */}
      <div className="pm-card__actions" onClick={(e) => e.stopPropagation()}>
        {!hasFeedback ? (
          <div className="pm-actions-group">
            <button
              className="pm-start"
              onClick={() => onResumeMeeting(pm)}
              aria-label="Start practice"
            >
              <Play fill='var(  --input)' size={16} /> Start
            </button>
          </div>
        ) : (
          <div className="pm-actions-group">
            <button
              className="pm-secondary"
              onClick={() => openFeedback(pm)}
              aria-label="Review meeting"
            >
              Feedback
            </button>
            <button
              className="pm-start"
              onClick={() => onResumeMeeting(pm)}
              aria-label="Retry meeting"
            >
              Retry
            </button>
          </div>
        )}

        <button
          className="pm-icon-btn"
          onClick={() => onDeleteMeeting(pm.id)}
          aria-label="Delete practice meeting"
        >
          <Trash2 size={18} />
        </button>
      </div>
    </article>
  );
})}

          </div>

          {/* Pagination */}
          <div className="userprofile-pagination">
            <Pagination page={meetPage} pages={meetPages} onChange={onPageChange} />
          </div>
        </>
      )}

      {activeMeeting && (
        <FeedbackModal
          meetingData={activeMeeting}
          feedback={activeMeeting.feedback?.feedback ?? ''}
          trainingPlan={activeMeeting.feedback?.trainingPlan ?? []}
          recording={activeMeeting.feedback?.recording ?? null}
          recordingAnalysis={activeMeeting.feedback?.recordingAnalysis ?? null}
          onClose={closeFeedback}
        />
      )}
    </section>
  );
}
